import { WorkbookTemplateDescriptionSmall } from '@tableau/workbook-templates-widgets';
import * as React from 'react';

import { CardViewStyles } from '../../app/spaces/CardView/CardViewStyles';
import { DetailsTooltipStyles } from '../../app/spaces/CardView/DetailsTooltipStyles';
import { TooltipAnchor } from '../../app/spaces/Tooltips/TooltipAnchor';
import { StartersDialogClickSourceOptions } from '../../common/telemetryEvents/TelemetryEvents';
import { L10n } from '../../ts/L10n/L10n';
import * as StartersStyles from '../styles/StarterStyles';
import { Starter } from '../types/StartersTypes';
import { displayDialogWithTemplate } from './InteractiveStarterModal';

export interface StartersCardProps {
  starter: Starter;
  startersGroupedByConnectionType: Starter[];
  moreLikeThisLink: string;
  testId: string;
}

export class StartersCard extends React.PureComponent<StartersCardProps> {
  public render() {
    return <div className={CardViewStyles.Card} data-tb-test-id={this.props.testId}>
      <CardThumbnail
        starter={this.props.starter}
        startersGroupedByConnectionType={this.props.startersGroupedByConnectionType}
        moreLikeThisLink={this.props.moreLikeThisLink}
        testId={this.props.testId}
      />
      {CardDescription(this.props.starter, this.props.testId)}
    </div>;
  }
}


export class CardThumbnail extends React.PureComponent<StartersCardProps> {
  private handleToolTipClick = () => {
    displayDialogWithTemplate(
      this.props.starter,
      this.props.startersGroupedByConnectionType,
      StartersDialogClickSourceOptions.HomeCardMoreLikeThis,
      this.props.startersGroupedByConnectionType.findIndex(
        (starterInternal: Starter) => starterInternal === this.props.starter
      )
    );
  }

  private getToolTip = () => {
    return <WorkbookTemplateDescriptionSmall starter={this.props.starter} handleClick={this.handleToolTipClick}/>;
  }

  private displayDialog = (source: StartersDialogClickSourceOptions): void => {
    displayDialogWithTemplate(
      this.props.starter,
      this.props.startersGroupedByConnectionType,
      source,
    );
  }

  private handleKeyDown = (e: React.KeyboardEvent<HTMLElement>): void => {
    if (e.key === 'Enter') {
      this.displayDialog(StartersDialogClickSourceOptions.HomeCard);
    }
  }

  public render() {
     /* eslint-disable jsx-a11y/no-static-element-interactions */
     /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
    return <span>
      <TooltipAnchor tooltipContent={this.getToolTip} width={DetailsTooltipStyles.Width} disableAutoFocus={true} title={''} >
          {
            <section
              className={`${CardViewStyles.Thumbnail} ${StartersStyles.StartersCardThumbnail}`}
              style={{ backgroundImage: `url('${this.props.starter.thumbnailUrl}')`, backgroundSize: 'contain', backgroundPositionX: 'center', backgroundPositionY: 'top' }}
              onClick={() => this.displayDialog(StartersDialogClickSourceOptions.HomeCard)}
              data-tb-test-id={`${this.props.testId}-thumbnail`}
              onKeyDown={this.handleKeyDown}
              tabIndex={0}
            >
            </section>
          }
      </TooltipAnchor>
    </span>;
  }
}

const CardDescription = (starter: Starter, testId: string) => {
  return (
    <div className={CardViewStyles.ActionRow}>
      <div
        title={L10n.elideIfLong(starter.connectionType.displayName)}
        className={CardViewStyles.ActionRowName}
        data-tb-test-id={`${testId}-description`}>
        {L10n.elideIfLong(starter.connectionType.displayName)}
      </div>
    </div>
  );
};
